/*
    PlatformApp item services are maintained manually.
    When an API item is added or removed, keep the imports, enum, and switch cases here
    synchronized with ItemServices.js and its completeness tests.
*/
import {
    AIAnalyticsItemService,
    AIAvailabilityPolicyItemService,
    AIChatItemService,
    AIChatSessionItemService,
    AIChatStepItemService,
    AILevelProfileItemService,
    AIModelCatalogItemService,
    AIModelPackageItemService,
    AIPromptItemService,
    AIProviderDeploymentItemService,
    AIProviderProfileItemService,
    AIProviderStateConformanceItemService,
    AIResourceProvisioningOperationItemService,
    AISharedFoundryShardItemService,
    As2MessageItemService,
    As2TradingPartnerItemService,
    BatchManagementPreferenceItemService,
    ClientApplicationOptionsItemService,
    ClientAuthenticationWorkspaceItemService,
    ClientAzureMapsConnectionFormItemService,
    ClientBillingControlRequestItemService,
    ClientBillingLedgerItemService,
    ClientBillingManualRowRequestItemService,
    ClientBillingProfileItemService,
    ClientBillingWorkspaceItemService,
    ClientCommandCapabilityItemService,
    ClientCommandCenterItemService,
    ClientCommandOperationResultItemService,
    ClientCommandScopeItemService,
    ClientCommandSummaryItemService,
    ClientCommandWorkspaceItemService,
    ClientCommunicationConfigurationItemService,
    ClientCommunicationProviderActionItemService,
    ClientCommunicationsWorkspaceItemService,
    ClientDatabasePartitionWorkspaceItemService,
    ClientDomainCommandItemService,
    ClientDomainGenerationRequestItemService,
    ClientDomainsWorkspaceItemService,
    ClientEntraConnectionFormItemService,
    ClientEntraMappingFormItemService,
    ClientEntraSetupScriptItemService,
    ClientFileCommandItemService,
    ClientFileStorageSetupItemService,
    ClientFilesWorkspaceItemService,
    ClientGuestAccessWorkspaceItemService,
    ClientInformationItemService,
    ClientOnboardingRunItemService,
    ClientOnboardingWizardItemService,
    ClientProductOfferItemService,
    ClientResourceItemService,
    ClientResourceActivityItemService,
    ClientRoleFormItemService,
    ClientRoleMappingFormItemService,
    ClientRolePermissionFormItemService,
    ClientRolesPermissionsWorkspaceItemService,
    ClientThemePairItemService,
    ClientThemePairsWorkspaceItemService,
    ClientUserProfileFormItemService,
    ClientUserProfilesWorkspaceItemService,
    ClientsWorkspaceItemService,
    ConvokeAppConfigItemService,
    DashboardItemService,
    DataModelItemService,
    DataModelWorkspaceItemService,
    DataModelWorkspaceArtifactVersionItemService,
    DataModelWorkspaceBuildRunItemService,
    DataQueryItemService,
    DataTypeItemService,
    DestinationScheduleItemService,
    DirtyRecordDeploymentItemService,
    EdiPartnerScopePolicyItemService,
    EdiTradingPartnerItemService,
    EdiTradingPartnerGroupItemService,
    EdiTradingPartnerGroupMemberItemService,
    EdiUsageLedgerItemService,
    EntityMasterRecordItemService,
    EntityMasterRecordMapItemService,
    EntityObjectItemService,
    EntityObjectFieldMapItemService,
    EntityObjectLoopMapItemService,
    EntityQueryItemService,
    ExternalAppItemService,
    ExternalAppSettingItemService,
    ExternalSystemItemService,
    ExternalSystemDirtyRecordItemService,
    ExternalSystemDirtyScanStateItemService,
    FeatureItemService,
    FileStorageItemService,
    FormConditionalItemService,
    IntegrationItemService,
    IntegrationSetupGuideItemService,
    MigrationMappingDraftItemService,
    MigrationProjectItemService,
    ModuleDefinitionItemService,
    ModulePermissionBaselineItemService,
    PricingEstimateSnapshotItemService,
    ProductDefinitionItemService,
    ProductMarketplaceAllowanceDefaultItemService,
    ProductMarketplaceCatalogItemService,
    ProductMarketplaceExposureDefaultItemService,
    ProductMarketplacePermissionSetEntryItemService,
    ProductMarketplacePricingEstimateDefaultItemService,
    ProductMarketplaceSetupBindingItemService,
    ProductMarketplaceSetupFieldDefinitionItemService,
    ProductMarketplaceSetupOperationBindingItemService,
    ProductMarketplaceSetupPathDefinitionItemService,
    ProductMarketplaceSetupSectionStepDefinitionItemService,
    ProductMarketplaceSetupStepDefinitionItemService,
    ProductMarketplaceUsagePricingDefaultItemService,
    ProductMarketplaceValidationReportItemService,
    ProductOfferCapacityGrantItemService,
    ProductOfferDefinitionItemService,
    ProductOfferPlacementItemService,
    ProductOfferPriceSnapshotItemService,
    ProductOfferResourceGrantItemService,
    ProductResourceDefinitionItemService,
    ProductResourceSetupPathDefinitionsItemService,
    ProductResourceSetupPathResultItemService,
    RemoteBatchHostItemService,
    ResourceAllowanceItemService,
    ResourceConfigurationItemService,
    ResourceConfigurationLinkedRecordItemService,
    ResourceConfigurationManagementSummaryItemService,
    ResourceConfigurationReadinessSnapshotItemService,
    ResourceConfigurationReviewSummaryItemService,
    ResourceConfigurationReviewSummaryFactItemService,
    ResourceConfigurationReviewSummaryRecordItemService,
    ResourceConfigurationReviewSummarySectionItemService,
    ResourceConfigurationSetupRunItemService,
    ResourceConfigurationSetupRunSectionStepItemService,
    ResourceConfigurationSetupRunStepItemService,
    ResourceConfigurationValidationIssueItemService,
    ResourceConfigurationWizardItemService,
    ResourceUsageEstimateItemService,
    ResourceUsageEstimateLineItemService,
    ResourceUsageEstimateSnapshotItemService,
    RuntimeCapacityLeaseItemService,
    SageCustomerItemService,
    SageVendorItemService,
    SchemaItemService,
    SchemaAPIItemService,
    SchemaAPIMcpOAuthClientItemService,
    SchemaDestinationLogItemService,
    SourceObjectItemService,
    SourceObjectRecordItemService,
    SourceQueryItemService,
    SourceSystemItemService,
    TransformScriptItemService,
    UserDashboardWorkspaceStateItemService,
    VisualItemService,
    VisualColorPaletteOptionItemService,
    VisualRenderOptionItemService,
    VisualTypeItemService,
    WarehouseItemService,
    WarehouseViewItemService,
    WarehouseViewFieldItemService,
    WarehouseViewQueryItemService
} from './ItemServices';
import {ItemServiceFactory as BaseItemServiceFactory} from 'spark-core-dx/services'

export class ItemServiceFactory {

get ItemServiceEnum() {
  return {
      ...BaseItemServiceFactory.ItemServiceEnum,
    AIAnalytics:"AIAnalytics",
    AIAvailabilityPolicy:"AIAvailabilityPolicy",
    AIChat:"AIChat",
    AIChatSession:"AIChatSession",
    AIChatStep:"AIChatStep",
    AILevelProfile:"AILevelProfile",
    AIModelCatalog:"AIModelCatalog",
    AIModelPackage:"AIModelPackage",
    AIPrompt:"AIPrompt",
    AIProviderDeployment:"AIProviderDeployment",
    AIProviderProfile:"AIProviderProfile",
    AIProviderStateConformance:"AIProviderStateConformance",
    AIResourceProvisioningOperation:"AIResourceProvisioningOperation",
    AISharedFoundryShard:"AISharedFoundryShard",
    As2Message:"As2Message",
    As2TradingPartner:"As2TradingPartner",
    BatchManagementPreference:"BatchManagementPreference",
    ClientApplicationOptions:"ClientApplicationOptions",
    ClientAuthenticationWorkspace:"ClientAuthenticationWorkspace",
    ClientAzureMapsConnectionForm:"ClientAzureMapsConnectionForm",
    ClientBillingControlRequest:"ClientBillingControlRequest",
    ClientBillingLedger:"ClientBillingLedger",
    ClientBillingManualRowRequest:"ClientBillingManualRowRequest",
    ClientBillingProfile:"ClientBillingProfile",
    ClientBillingWorkspace:"ClientBillingWorkspace",
    ClientCommandCapability:"ClientCommandCapability",
    ClientCommandCenter:"ClientCommandCenter",
    ClientCommandOperationResult:"ClientCommandOperationResult",
    ClientCommandScope:"ClientCommandScope",
    ClientCommandSummary:"ClientCommandSummary",
    ClientCommandWorkspace:"ClientCommandWorkspace",
    ClientCommunicationConfiguration:"ClientCommunicationConfiguration",
    ClientCommunicationProviderAction:"ClientCommunicationProviderAction",
    ClientCommunicationsWorkspace:"ClientCommunicationsWorkspace",
    ClientDatabasePartitionWorkspace:"ClientDatabasePartitionWorkspace",
    ClientDomainCommand:"ClientDomainCommand",
    ClientDomainGenerationRequest:"ClientDomainGenerationRequest",
    ClientDomainsWorkspace:"ClientDomainsWorkspace",
    ClientEntraConnectionForm:"ClientEntraConnectionForm",
    ClientEntraMappingForm:"ClientEntraMappingForm",
    ClientEntraSetupScript:"ClientEntraSetupScript",
    ClientFileCommand:"ClientFileCommand",
    ClientFileStorageSetup:"ClientFileStorageSetup",
    ClientFilesWorkspace:"ClientFilesWorkspace",
    ClientGuestAccessWorkspace:"ClientGuestAccessWorkspace",
    ClientInformation:"ClientInformation",
    ClientOnboardingRun:"ClientOnboardingRun",
    ClientOnboardingWizard:"ClientOnboardingWizard",
    ClientProductOffer:"ClientProductOffer",
    ClientResource:"ClientResource",
    ClientResourceActivity:"ClientResourceActivity",
    ClientRoleForm:"ClientRoleForm",
    ClientRoleMappingForm:"ClientRoleMappingForm",
    ClientRolePermissionForm:"ClientRolePermissionForm",
    ClientRolesPermissionsWorkspace:"ClientRolesPermissionsWorkspace",
    ClientThemePair:"ClientThemePair",
    ClientThemePairsWorkspace:"ClientThemePairsWorkspace",
    ClientUserProfileForm:"ClientUserProfileForm",
    ClientUserProfilesWorkspace:"ClientUserProfilesWorkspace",
    ClientsWorkspace:"ClientsWorkspace",
    ConvokeAppConfig:"ConvokeAppConfig",
    Dashboard:"Dashboard",
    DataModel:"DataModel",
    DataModelWorkspace:"DataModelWorkspace",
    DataModelWorkspaceArtifactVersion:"DataModelWorkspaceArtifactVersion",
    DataModelWorkspaceBuildRun:"DataModelWorkspaceBuildRun",
    DataQuery:"DataQuery",
    DataType:"DataType",
    DestinationSchedule:"DestinationSchedule",
    DirtyRecordDeployment:"DirtyRecordDeployment",
    EdiPartnerScopePolicy:"EdiPartnerScopePolicy",
    EdiTradingPartner:"EdiTradingPartner",
    EdiTradingPartnerGroup:"EdiTradingPartnerGroup",
    EdiTradingPartnerGroupMember:"EdiTradingPartnerGroupMember",
    EdiUsageLedger:"EdiUsageLedger",
    EntityMasterRecord:"EntityMasterRecord",
    EntityMasterRecordMap:"EntityMasterRecordMap",
    EntityObject:"EntityObject",
    EntityObjectFieldMap:"EntityObjectFieldMap",
    EntityObjectLoopMap:"EntityObjectLoopMap",
    EntityQuery:"EntityQuery",
    ExternalApp:"ExternalApp",
    ExternalAppSetting:"ExternalAppSetting",
    ExternalSystem:"ExternalSystem",
    ExternalSystemDirtyRecord:"ExternalSystemDirtyRecord",
    ExternalSystemDirtyScanState:"ExternalSystemDirtyScanState",
    Feature:"Feature",
    FileStorage:"FileStorage",
    FormConditional:"FormConditional",
    Integration:"Integration",
    IntegrationSetupGuide:"IntegrationSetupGuide",
    MigrationMappingDraft:"MigrationMappingDraft",
    MigrationProject:"MigrationProject",
    ModuleDefinition:"ModuleDefinition",
    ModulePermissionBaseline:"ModulePermissionBaseline",
    PricingEstimateSnapshot:"PricingEstimateSnapshot",
    ProductDefinition:"ProductDefinition",
    ProductMarketplaceAllowanceDefault:"ProductMarketplaceAllowanceDefault",
    ProductMarketplaceCatalog:"ProductMarketplaceCatalog",
    ProductMarketplaceExposureDefault:"ProductMarketplaceExposureDefault",
    ProductMarketplacePermissionSetEntry:"ProductMarketplacePermissionSetEntry",
    ProductMarketplacePricingEstimateDefault:"ProductMarketplacePricingEstimateDefault",
    ProductMarketplaceSetupBinding:"ProductMarketplaceSetupBinding",
    ProductMarketplaceSetupFieldDefinition:"ProductMarketplaceSetupFieldDefinition",
    ProductMarketplaceSetupOperationBinding:"ProductMarketplaceSetupOperationBinding",
    ProductMarketplaceSetupPathDefinition:"ProductMarketplaceSetupPathDefinition",
    ProductMarketplaceSetupSectionStepDefinition:"ProductMarketplaceSetupSectionStepDefinition",
    ProductMarketplaceSetupStepDefinition:"ProductMarketplaceSetupStepDefinition",
    ProductMarketplaceUsagePricingDefault:"ProductMarketplaceUsagePricingDefault",
    ProductMarketplaceValidationReport:"ProductMarketplaceValidationReport",
    ProductOfferCapacityGrant:"ProductOfferCapacityGrant",
    ProductOfferDefinition:"ProductOfferDefinition",
    ProductOfferPlacement:"ProductOfferPlacement",
    ProductOfferPriceSnapshot:"ProductOfferPriceSnapshot",
    ProductOfferResourceGrant:"ProductOfferResourceGrant",
    ProductResourceDefinition:"ProductResourceDefinition",
    ProductResourceSetupPathDefinitions:"ProductResourceSetupPathDefinitions",
    ProductResourceSetupPathResult:"ProductResourceSetupPathResult",
    RemoteBatchHost:"RemoteBatchHost",
    ResourceAllowance:"ResourceAllowance",
    ResourceConfiguration:"ResourceConfiguration",
    ResourceConfigurationLinkedRecord:"ResourceConfigurationLinkedRecord",
    ResourceConfigurationManagementSummary:"ResourceConfigurationManagementSummary",
    ResourceConfigurationReadinessSnapshot:"ResourceConfigurationReadinessSnapshot",
    ResourceConfigurationReviewSummary:"ResourceConfigurationReviewSummary",
    ResourceConfigurationReviewSummaryFact:"ResourceConfigurationReviewSummaryFact",
    ResourceConfigurationReviewSummaryRecord:"ResourceConfigurationReviewSummaryRecord",
    ResourceConfigurationReviewSummarySection:"ResourceConfigurationReviewSummarySection",
    ResourceConfigurationSetupRun:"ResourceConfigurationSetupRun",
    ResourceConfigurationSetupRunSectionStep:"ResourceConfigurationSetupRunSectionStep",
    ResourceConfigurationSetupRunStep:"ResourceConfigurationSetupRunStep",
    ResourceConfigurationValidationIssue:"ResourceConfigurationValidationIssue",
    ResourceConfigurationWizard:"ResourceConfigurationWizard",
    ResourceUsageEstimate:"ResourceUsageEstimate",
    ResourceUsageEstimateLine:"ResourceUsageEstimateLine",
    ResourceUsageEstimateSnapshot:"ResourceUsageEstimateSnapshot",
    RuntimeCapacityLease:"RuntimeCapacityLease",
    SageCustomer:"SageCustomer",
    SageVendor:"SageVendor",
    Schema:"Schema",
    SchemaAPI:"SchemaAPI",
    SchemaAPIMcpOAuthClient:"SchemaAPIMcpOAuthClient",
    SchemaDestinationLog:"SchemaDestinationLog",
    SourceObject:"SourceObject",
    SourceObjectRecord:"SourceObjectRecord",
    SourceQuery:"SourceQuery",
    SourceSystem:"SourceSystem",
    TransformScript:"TransformScript",
    UserDashboardWorkspaceState:"UserDashboardWorkspaceState",
    Visual:"Visual",
    VisualColorPaletteOption:"VisualColorPaletteOption",
    VisualRenderOption:"VisualRenderOption",
    VisualType:"VisualType",
    Warehouse:"Warehouse",
    WarehouseView:"WarehouseView",
    WarehouseViewField:"WarehouseViewField",
    WarehouseViewQuery:"WarehouseViewQuery",
  }
}

GetItemService(itemServiceName, coreState, coreContext, isWarning) {
    if(itemServiceName === undefined) throw new Error('Item service name not found, please regenerate the Item Services to resolve this issue.');
    let itemService;
    switch(itemServiceName.toLowerCase()){
        case this.ItemServiceEnum.AIAnalytics.toLowerCase():
             itemService = new AIAnalyticsItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIAvailabilityPolicy.toLowerCase():
             itemService = new AIAvailabilityPolicyItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChat.toLowerCase():
             itemService = new AIChatItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChatSession.toLowerCase():
             itemService = new AIChatSessionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIChatStep.toLowerCase():
             itemService = new AIChatStepItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AILevelProfile.toLowerCase():
             itemService = new AILevelProfileItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIModelCatalog.toLowerCase():
             itemService = new AIModelCatalogItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIModelPackage.toLowerCase():
             itemService = new AIModelPackageItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIPrompt.toLowerCase():
             itemService = new AIPromptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIProviderDeployment.toLowerCase():
             itemService = new AIProviderDeploymentItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIProviderProfile.toLowerCase():
             itemService = new AIProviderProfileItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIProviderStateConformance.toLowerCase():
             itemService = new AIProviderStateConformanceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AIResourceProvisioningOperation.toLowerCase():
             itemService = new AIResourceProvisioningOperationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.AISharedFoundryShard.toLowerCase():
             itemService = new AISharedFoundryShardItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.As2Message.toLowerCase():
             itemService = new As2MessageItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.As2TradingPartner.toLowerCase():
             itemService = new As2TradingPartnerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.BatchManagementPreference.toLowerCase():
             itemService = new BatchManagementPreferenceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientApplicationOptions.toLowerCase():
             itemService = new ClientApplicationOptionsItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientAuthenticationWorkspace.toLowerCase():
             itemService = new ClientAuthenticationWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientAzureMapsConnectionForm.toLowerCase():
             itemService = new ClientAzureMapsConnectionFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingControlRequest.toLowerCase():
             itemService = new ClientBillingControlRequestItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingLedger.toLowerCase():
             itemService = new ClientBillingLedgerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingManualRowRequest.toLowerCase():
             itemService = new ClientBillingManualRowRequestItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingProfile.toLowerCase():
             itemService = new ClientBillingProfileItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientBillingWorkspace.toLowerCase():
             itemService = new ClientBillingWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandCapability.toLowerCase():
             itemService = new ClientCommandCapabilityItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandCenter.toLowerCase():
             itemService = new ClientCommandCenterItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandOperationResult.toLowerCase():
             itemService = new ClientCommandOperationResultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandScope.toLowerCase():
             itemService = new ClientCommandScopeItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandSummary.toLowerCase():
             itemService = new ClientCommandSummaryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommandWorkspace.toLowerCase():
             itemService = new ClientCommandWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommunicationConfiguration.toLowerCase():
             itemService = new ClientCommunicationConfigurationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommunicationProviderAction.toLowerCase():
             itemService = new ClientCommunicationProviderActionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientCommunicationsWorkspace.toLowerCase():
             itemService = new ClientCommunicationsWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientDatabasePartitionWorkspace.toLowerCase():
             itemService = new ClientDatabasePartitionWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientDomainCommand.toLowerCase():
             itemService = new ClientDomainCommandItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientDomainGenerationRequest.toLowerCase():
             itemService = new ClientDomainGenerationRequestItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientDomainsWorkspace.toLowerCase():
             itemService = new ClientDomainsWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientEntraConnectionForm.toLowerCase():
             itemService = new ClientEntraConnectionFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientEntraMappingForm.toLowerCase():
             itemService = new ClientEntraMappingFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientEntraSetupScript.toLowerCase():
             itemService = new ClientEntraSetupScriptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientFileCommand.toLowerCase():
             itemService = new ClientFileCommandItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientFileStorageSetup.toLowerCase():
             itemService = new ClientFileStorageSetupItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientFilesWorkspace.toLowerCase():
             itemService = new ClientFilesWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientGuestAccessWorkspace.toLowerCase():
             itemService = new ClientGuestAccessWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientInformation.toLowerCase():
             itemService = new ClientInformationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientOnboardingRun.toLowerCase():
             itemService = new ClientOnboardingRunItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientOnboardingWizard.toLowerCase():
             itemService = new ClientOnboardingWizardItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientProductOffer.toLowerCase():
             itemService = new ClientProductOfferItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientResource.toLowerCase():
             itemService = new ClientResourceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientResourceActivity.toLowerCase():
             itemService = new ClientResourceActivityItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientRoleForm.toLowerCase():
             itemService = new ClientRoleFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientRoleMappingForm.toLowerCase():
             itemService = new ClientRoleMappingFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientRolePermissionForm.toLowerCase():
             itemService = new ClientRolePermissionFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientRolesPermissionsWorkspace.toLowerCase():
             itemService = new ClientRolesPermissionsWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientThemePair.toLowerCase():
             itemService = new ClientThemePairItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientThemePairsWorkspace.toLowerCase():
             itemService = new ClientThemePairsWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientUserProfileForm.toLowerCase():
             itemService = new ClientUserProfileFormItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientUserProfilesWorkspace.toLowerCase():
             itemService = new ClientUserProfilesWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ClientsWorkspace.toLowerCase():
             itemService = new ClientsWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ConvokeAppConfig.toLowerCase():
             itemService = new ConvokeAppConfigItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Dashboard.toLowerCase():
             itemService = new DashboardItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModel.toLowerCase():
             itemService = new DataModelItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspace.toLowerCase():
             itemService = new DataModelWorkspaceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspaceArtifactVersion.toLowerCase():
             itemService = new DataModelWorkspaceArtifactVersionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataModelWorkspaceBuildRun.toLowerCase():
             itemService = new DataModelWorkspaceBuildRunItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataQuery.toLowerCase():
             itemService = new DataQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DataType.toLowerCase():
             itemService = new DataTypeItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DestinationSchedule.toLowerCase():
             itemService = new DestinationScheduleItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.DirtyRecordDeployment.toLowerCase():
             itemService = new DirtyRecordDeploymentItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiPartnerScopePolicy.toLowerCase():
             itemService = new EdiPartnerScopePolicyItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiTradingPartner.toLowerCase():
             itemService = new EdiTradingPartnerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiTradingPartnerGroup.toLowerCase():
             itemService = new EdiTradingPartnerGroupItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiTradingPartnerGroupMember.toLowerCase():
             itemService = new EdiTradingPartnerGroupMemberItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EdiUsageLedger.toLowerCase():
             itemService = new EdiUsageLedgerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecord.toLowerCase():
             itemService = new EntityMasterRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityMasterRecordMap.toLowerCase():
             itemService = new EntityMasterRecordMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObject.toLowerCase():
             itemService = new EntityObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObjectFieldMap.toLowerCase():
             itemService = new EntityObjectFieldMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityObjectLoopMap.toLowerCase():
             itemService = new EntityObjectLoopMapItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.EntityQuery.toLowerCase():
             itemService = new EntityQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalApp.toLowerCase():
             itemService = new ExternalAppItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalAppSetting.toLowerCase():
             itemService = new ExternalAppSettingItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystem.toLowerCase():
             itemService = new ExternalSystemItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystemDirtyRecord.toLowerCase():
             itemService = new ExternalSystemDirtyRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ExternalSystemDirtyScanState.toLowerCase():
             itemService = new ExternalSystemDirtyScanStateItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Feature.toLowerCase():
             itemService = new FeatureItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.FileStorage.toLowerCase():
             itemService = new FileStorageItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.FormConditional.toLowerCase():
             itemService = new FormConditionalItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Integration.toLowerCase():
             itemService = new IntegrationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.IntegrationSetupGuide.toLowerCase():
             itemService = new IntegrationSetupGuideItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.MigrationMappingDraft.toLowerCase():
             itemService = new MigrationMappingDraftItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.MigrationProject.toLowerCase():
             itemService = new MigrationProjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ModuleDefinition.toLowerCase():
             itemService = new ModuleDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ModulePermissionBaseline.toLowerCase():
             itemService = new ModulePermissionBaselineItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.PricingEstimateSnapshot.toLowerCase():
             itemService = new PricingEstimateSnapshotItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductDefinition.toLowerCase():
             itemService = new ProductDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceAllowanceDefault.toLowerCase():
             itemService = new ProductMarketplaceAllowanceDefaultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceCatalog.toLowerCase():
             itemService = new ProductMarketplaceCatalogItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceExposureDefault.toLowerCase():
             itemService = new ProductMarketplaceExposureDefaultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplacePermissionSetEntry.toLowerCase():
             itemService = new ProductMarketplacePermissionSetEntryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplacePricingEstimateDefault.toLowerCase():
             itemService = new ProductMarketplacePricingEstimateDefaultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupBinding.toLowerCase():
             itemService = new ProductMarketplaceSetupBindingItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupFieldDefinition.toLowerCase():
             itemService = new ProductMarketplaceSetupFieldDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupOperationBinding.toLowerCase():
             itemService = new ProductMarketplaceSetupOperationBindingItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupPathDefinition.toLowerCase():
             itemService = new ProductMarketplaceSetupPathDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupSectionStepDefinition.toLowerCase():
             itemService = new ProductMarketplaceSetupSectionStepDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceSetupStepDefinition.toLowerCase():
             itemService = new ProductMarketplaceSetupStepDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceUsagePricingDefault.toLowerCase():
             itemService = new ProductMarketplaceUsagePricingDefaultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductMarketplaceValidationReport.toLowerCase():
             itemService = new ProductMarketplaceValidationReportItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductOfferCapacityGrant.toLowerCase():
             itemService = new ProductOfferCapacityGrantItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductOfferDefinition.toLowerCase():
             itemService = new ProductOfferDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductOfferPlacement.toLowerCase():
             itemService = new ProductOfferPlacementItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductOfferPriceSnapshot.toLowerCase():
             itemService = new ProductOfferPriceSnapshotItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductOfferResourceGrant.toLowerCase():
             itemService = new ProductOfferResourceGrantItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductResourceDefinition.toLowerCase():
             itemService = new ProductResourceDefinitionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductResourceSetupPathDefinitions.toLowerCase():
             itemService = new ProductResourceSetupPathDefinitionsItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ProductResourceSetupPathResult.toLowerCase():
             itemService = new ProductResourceSetupPathResultItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.RemoteBatchHost.toLowerCase():
             itemService = new RemoteBatchHostItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceAllowance.toLowerCase():
             itemService = new ResourceAllowanceItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfiguration.toLowerCase():
             itemService = new ResourceConfigurationItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationLinkedRecord.toLowerCase():
             itemService = new ResourceConfigurationLinkedRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationManagementSummary.toLowerCase():
             itemService = new ResourceConfigurationManagementSummaryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationReadinessSnapshot.toLowerCase():
             itemService = new ResourceConfigurationReadinessSnapshotItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationReviewSummary.toLowerCase():
             itemService = new ResourceConfigurationReviewSummaryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationReviewSummaryFact.toLowerCase():
             itemService = new ResourceConfigurationReviewSummaryFactItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationReviewSummaryRecord.toLowerCase():
             itemService = new ResourceConfigurationReviewSummaryRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationReviewSummarySection.toLowerCase():
             itemService = new ResourceConfigurationReviewSummarySectionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationSetupRun.toLowerCase():
             itemService = new ResourceConfigurationSetupRunItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationSetupRunSectionStep.toLowerCase():
             itemService = new ResourceConfigurationSetupRunSectionStepItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationSetupRunStep.toLowerCase():
             itemService = new ResourceConfigurationSetupRunStepItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationValidationIssue.toLowerCase():
             itemService = new ResourceConfigurationValidationIssueItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceConfigurationWizard.toLowerCase():
             itemService = new ResourceConfigurationWizardItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceUsageEstimate.toLowerCase():
             itemService = new ResourceUsageEstimateItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceUsageEstimateLine.toLowerCase():
             itemService = new ResourceUsageEstimateLineItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.ResourceUsageEstimateSnapshot.toLowerCase():
             itemService = new ResourceUsageEstimateSnapshotItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.RuntimeCapacityLease.toLowerCase():
             itemService = new RuntimeCapacityLeaseItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageCustomer.toLowerCase():
             itemService = new SageCustomerItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SageVendor.toLowerCase():
             itemService = new SageVendorItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Schema.toLowerCase():
             itemService = new SchemaItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaAPI.toLowerCase():
             itemService = new SchemaAPIItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaAPIMcpOAuthClient.toLowerCase():
             itemService = new SchemaAPIMcpOAuthClientItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SchemaDestinationLog.toLowerCase():
             itemService = new SchemaDestinationLogItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObject.toLowerCase():
             itemService = new SourceObjectItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceObjectRecord.toLowerCase():
             itemService = new SourceObjectRecordItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceQuery.toLowerCase():
             itemService = new SourceQueryItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.SourceSystem.toLowerCase():
             itemService = new SourceSystemItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.TransformScript.toLowerCase():
             itemService = new TransformScriptItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.UserDashboardWorkspaceState.toLowerCase():
             itemService = new UserDashboardWorkspaceStateItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Visual.toLowerCase():
             itemService = new VisualItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.VisualColorPaletteOption.toLowerCase():
             itemService = new VisualColorPaletteOptionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.VisualRenderOption.toLowerCase():
             itemService = new VisualRenderOptionItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.VisualType.toLowerCase():
             itemService = new VisualTypeItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.Warehouse.toLowerCase():
             itemService = new WarehouseItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.WarehouseView.toLowerCase():
             itemService = new WarehouseViewItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.WarehouseViewField.toLowerCase():
             itemService = new WarehouseViewFieldItemService(coreState, coreContext, isWarning);
             break;
        case this.ItemServiceEnum.WarehouseViewQuery.toLowerCase():
             itemService = new WarehouseViewQueryItemService(coreState, coreContext, isWarning);
             break;
        default:
            itemService = BaseItemServiceFactory.GetItemService(itemServiceName, coreState, coreContext, isWarning);
            break;
        }
        return itemService;
    }

ValidateItemName(itemName) {
    let isValid = false;
    for (const key in this.ItemServiceEnum){
        if (typeof(this.ItemServiceEnum[key]) === "string" &&
                this.ItemServiceEnum[key].toLowerCase() === itemName.toLowerCase())
                {
                    isValid = true;
                    break;
                }
        }
     return isValid || BaseItemServiceFactory.ValidateItemName(itemName);
 }
}
